import { InferType, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object({
  participantRole: string().required(),
  participantName: string().optional(),
  eventStreamId: string().required(),
}).required()

export type Request = InferType<typeof Schema>

export interface SuccessfulResponse {
  data: {
    participant: {
      call_sid: string
      phone_number: string
      label: string
      status: string
    }
  }
}

export const url = ({ eventStreamId }: { eventStreamId: string }) =>
  `/v2/crisis-streams/${eventStreamId}/call-participants`

export const getBody = ({ participantRole, participantName }: Request) => ({
  participantRole,
  ...(participantName && { participantName }),
})
